import { servicesListData } from "@/lib/data/services-data";

// Types
export interface ServiceItem {
	id: number;
	href: string;
	label: string;
	description: string;
	keywords: string[];
	faqs: { question: string; answer: string }[];
}

// Custom Errors
export class ServiceNotFoundError {
	readonly _tag = "ServiceNotFoundError";
	constructor(public readonly slug: string) {}
}

/**
 * Get all services
 */
export const getAllServices = async () => {
	return servicesListData;
};

/**
 * Get a single service by slug
 */
export const getServiceBySlug = async (slug: string) => {
	const services = await getAllServices();
	const service = services.find(
		(s) => s.href.replace("/services/", "").replace(/\/$/, "") === slug,
	);

	if (!service) {
		throw new ServiceNotFoundError(slug);
	}

	return service;
};
